import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './App';
import Board from './Board'
import Events from './Events'
import Newsletter from './Newsletter';
import reportWebVitals from './reportWebVitals';
import { HashRouter, Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/board" element={<Board />} />
        <Route path="/events" element={<Events />} />
        <Route path="/newsletter" element={<Newsletter />} />
      </Routes>
    </HashRouter>
  );
};

// Use ReactDOM.createRoot for rendering in React 18+
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
